export function SkeletonCard() {
  return (
    <div className="rounded-2xl border border-border bg-surface p-5 shadow-soft">
      <div className="skeleton h-5 w-3/4 rounded" />
      <div className="mt-3 space-y-2">
        <div className="skeleton h-3 rounded" />
        <div className="skeleton h-3 w-5/6 rounded" />
      </div>
      <div className="mt-4 flex gap-2">
        <div className="skeleton h-5 w-14 rounded-full" />
        <div className="skeleton h-5 w-10 rounded-full" />
      </div>
    </div>
  );
}
